const videoFormats = ["mov", "mp4", "webm"]

export const isVideoByUrl = (url: string) => {
    return videoFormats.some((format) =>
        url.toLocaleLowerCase().includes(format),
    )
}
